import { template as template_80997cd298bc4683a0b9e315a9706bc6 } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import { cn } from '../-private/helpers/cn.ts';
export interface VelvetSpinnerSignature {
    Args: {
        /// The size of the spinner.
        /// @default ["md"]
        size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    };
    Element: SVGElement;
}
const VelvetSpinner: TOC<VelvetSpinnerSignature> = template_80997cd298bc4683a0b9e315a9706bc6(`
  <svg
    class={{cn
      "velvet-spinner"
      (concat "velvet-spinner-" (or @size "md"))
    }}
    fill="none"
    role="status"
    stroke="currentColor"
    stroke-width="10"
    viewBox="0 0 80 80"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <circle class="velvet-spinner-track" cx="40" cy="40" r="35"></circle>
    <circle
      class="velvet-spinner-line"
      cx="40"
      cy="40"
      r="35"
      stroke-dasharray="40, 160"
      stroke-linecap="round"
    ></circle>
  </svg>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default VelvetSpinner;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3ZlbHZldC10aHVuZGVyL3ZlbHZldC10aHVuZGVyL3ZlbHZldC10aHVuZGVyL3NyYy9jb21wb25lbnRzL3ZlbHZldC1zcGlubmVyLmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFRPQyB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5pbXBvcnQgeyBjb25jYXQgfSBmcm9tICdAZW1iZXIvaGVscGVyJztcbmltcG9ydCB7IG9yIH0gZnJvbSAnZW1iZXItdHJ1dGgtaGVscGVycyc7XG5pbXBvcnQgeyBjbiB9IGZyb20gJy4uLy1wcml2YXRlL2hlbHBlcnMvY24udHMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFZlbHZldFNwaW5uZXJTaWduYXR1cmUge1xuICBBcmdzOiB7XG4gICAgLy8vIFRoZSBzaXplIG9mIHRoZSBzcGlubmVyLlxuICAgIC8vLyBAZGVmYXVsdCBbXCJtZFwiXVxuICAgIHNpemU_OiAneHMnIHwgJ3NtJyB8ICdtZCcgfCAnbGcnIHwgJ3hsJztcbiAgfTtcbiAgRWxlbWVudDogU1ZHRWxlbWVudDtcbn1cblxuY29uc3QgVmVsdmV0U3Bpbm5lcjogVE9DPFZlbHZldFNwaW5uZXJTaWduYXR1cmU-ID0gPHRlbXBsYXRlPlxuICA8c3ZnXG4gICAgY2xhc3M9e3tjblxuICAgICAgXCJ2ZWx2ZXQtc3Bpbm5lclwiXG4gICAgICAoY29uY2F0IFwidmVsdmV0LXNwaW5uZXItXCIgKG9yIEBzaXplIFwibWRcIikpXG4gICAgfX1cbiAgICBmaWxsPVwibm9uZVwiXG4gICAgcm9sZT1cInN0YXR1c1wiXG4gICAgc3Ryb2tlPVwiY3VycmVudENvbG9yXCJcbiAgICBzdHJva2Utd2lkdGg9XCIxMFwiXG4gICAgdmlld0JveD1cIjAgMCA4MCA4MFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgLi4uYXR0cmlidXRlc1xuICA-XG4gICAgPGNpcmNsZSBjbGFzcz1cInZlbHZldC1zcGlubmVyLXRyYWNrXCIgY3g9XCI0MFwiIGN5PVwiNDBcIiByPVwiMzVcIj48L2NpcmNsZT5cbiAgICA8Y2lyY2xlXG4gICAgICBjbGFzcz1cInZlbHZldC1zcGlubmVyLWxpbmVcIlxuICAgICAgY3g9XCI0MFwiXG4gICAgICBjeT1cIjQwXCJcbiAgICAgIHI9XCIzNVwiXG4gICAgICBzdHJva2UtZGFzaGFycmF5PVwiNDAsIDE2MFwiXG4gICAgICBzdHJva2UtbGluZWNhcD1cInJvdW5kXCJcbiAgICA-PC9jaXJjbGU-XG4gIDwvc3ZnPlxuPC90ZW1wbGF0ZT47XG5cbmV4cG9ydCBkZWZhdWx0IFZlbHZldFNwaW5uZXI7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUMxRCxTQUFTLE1BQU0sUUFBUSxnQkFBZ0I7QUFDdkMsU0FBUyxFQUFFLFFBQVEsc0JBQXNCO0FBQ3pDLFNBQVMsRUFBRSxRQUFRLDRCQUE0QjtBQUUvQyxpQkFBaUI7SUFDZjtRQUNFLDRCQUE0QjtRQUM1QixtQkFBbUI7UUFDbkIsT0FBTyxPQUFPLE9BQU8sT0FBTyxPQUFPOztJQUVyQyxTQUFTOztBQUdYLE1BQU0sZUFBZSxJQUFJLDBCQUEwQiwwQ0FBVSxDQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUF3QjdELENBQUEsRUFBQTtJQUFBO1FBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO0lBQUQ7QUFBQTtBQUVWLGVBQWUsY0FBYyJ9